import React, { MouseEvent } from 'react';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

const BackIcon = ({ className, onClick }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={className} onClick={onClick}>
      <g clipPath="url(#clip0_2182_2083)">
        <path d="M11.6736 2.57999L10.4869 1.39999L3.89355 7.99999L10.4936 14.6L11.6736 13.42L6.25355 7.99999L11.6736 2.57999Z" fill="#323232"/>
      </g>
      <defs>
        <clipPath id="clip0_2182_2083">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default BackIcon;
